import React, { useContext } from 'react'
import { useToast } from '@cjdev-internal/visual-stack-x/Toast'
import { CommissionAdminValues, FetchResponse, ToastOptions } from '../../../types'
import CommissionAdminContext from '../../../context/CommissionAdminContext'

const Notification = () => {
  const [mount, show, dismiss] = useToast(true);
  const { eventEmitter } = useContext<CommissionAdminValues>(CommissionAdminContext);

  //Notification Callback
  const showNotification = (toastOptions: ToastOptions) => {
    show(toastOptions);
  }

  //Register event
  React.useEffect(() => {
    eventEmitter.on('SHOW_TOAST', showNotification);
    return () => {
      eventEmitter.removeListener('SHOW_TOAST', showNotification);
    };
  }, []);

  return (
    <>
      {mount}
    </>
  )
}


export default Notification